export default [
  {
    text: 'Short Code',
    value: 'short_code',
    sortable: true,
  },
  {
    text: 'Texted',
    value: 'total_inbound_texts',
    sortable: true,
  },
  {
    text: 'Clicks',
    value: 'shortened_url_data.total_referrals',
    sortable: false,
  },
  {
    text: 'Long URL',
    value: 'callback_url',
    sortable: true,
  },
  {
    text: 'Short URL',
    value: 'shortened_url',
    sortable: true,
  },
  {
    text: 'Text Auto Response',
    value: 'automated_response',
    sortable: false,
  },
  {
    text: 'Contact Source',
    value: 'contact_source.name',
    sortable: false,
  },
  {
    text: 'Campaign',
    value: 'campaign.name',
    sortable: false,
  },
];
